(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class luminLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.lumin-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        setTimeout(() => {
          tooltip.classList.remove('show')
          tooltip.classList.add('hiding')
          setTimeout(() => {
            tooltip.classList.remove('hiding')
          }, 200)
        }, 100)
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('lumin-lookbook', luminLookBook)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-video-new"] && !Shopify.designMode) return;
  try {
    
class KsShoppableVideos extends HTMLElement {
  constructor () {
    super()
/*
    if (!document.querySelector('#swiper-stylesheet')) {
      const stylesheet = document.createElement('link')
      stylesheet.setAttribute('href', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.css')
      stylesheet.setAttribute('rel', 'stylesheet')
      stylesheet.setAttribute('id', 'swiper-stylesheet')
      stylesheet.setAttribute('integrity', 'sha256-5nkrwjVsiNfKz3NR1k2h5+qt5pS5SF2u9/TIT1hElow=')
      stylesheet.setAttribute('crossorigin', 'anonymous')
      document.head.appendChild(stylesheet)
    }

    if (!document.querySelector('#swiper-script')) {
      const script = document.createElement('script')
      script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.js')
      script.setAttribute('id', 'swiper-script')
      script.setAttribute('integrity', 'sha256-rCACDWCp/VzIh0rsB+ipQCM9XBvO8HNe0fNSOa4sys0=')
      script.setAttribute('crossorigin', 'anonymous')
      document.head.appendChild(script)
    }
*/
    setTimeout(() => {
      const slider = new window.Swiper(this.querySelector('.swiper'), this.splideOptions())

      slider.on('slideChange', () => {
        this.querySelector('.swiper').classList.add('swiper-is-changing')
        this.onSlideChange()
      })

      slider.on('slideChangeTransitionEnd', () => {
        this.querySelector('.swiper').classList.remove('swiper-is-changing')
      })
    }, 500)
    
    this.querySelectorAll('.lumin-shoppable-videos-btn-play').forEach(btn => {
      btn.addEventListener('click', () => {
        const video = btn.closest('.lumin-shoppable-videos-video-wrapper').querySelector('video')
        this.onVideoPlay(video)
      })
    })

    this.querySelectorAll('video').forEach(video => {
      video.addEventListener('click', () => {
        this.onVideoPlay(video)
      })
    })

    const lazyVideosObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.play()
        }
      })
    }, { rootMargin: '0px 0px 300px 0px' })
    
    this.querySelectorAll('video[data-autoplay="true"]').forEach((el) => {
      lazyVideosObserver.observe(el)
    })
  }

  splideOptions () {
    const partialSlidesMobile = this.dataset.partialSlidesMobile === 'true' ? 1.2 : 1

    /** @type {SwiperOptions} */
    const options = {
      rewind: true,
      speed: Number(this.dataset.sliderSpeed),
      breakpoints: {
        0: { slidesPerView: Number(this.dataset.breakpointXs) * partialSlidesMobile },
        576: { slidesPerView: Number(this.dataset.breakpointSm) },
        768: { slidesPerView: Number(this.dataset.breakpointMd) },
        992: { slidesPerView: Number(this.dataset.breakpointLg) },
        1200: { slidesPerView: Number(this.dataset.breakpointXl) },
        1400: { slidesPerView: Number(this.dataset.breakpointXxl) }
      },
      navigation: {
        enabled: this.dataset.sliderNav === 'true',
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev')
      },
      pagination: {
        enabled: this.dataset.sliderPagination === 'true',
        type: this.dataset.sliderPaginationType,
        el: '.swiper-pagination',
        dynamicBullets: true,
        dynamicMainBullets: 2,
        renderFraction: function (currentClass, totalClass) {
          return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`
        }
      },
      scrollbar: {
        enabled: this.dataset.sliderScrollbar === 'true',
        el: this.querySelector('.swiper-scrollbar'),
        draggable: true
        // hide: true
      },
      autoplay: this.dataset.sliderAutoplay !== '0'
        ? { delay: Number(this.dataset.sliderAutoplay) * 1000 }
        : undefined,
      watchSlidesProgress: true, 
      mousewheel: {
        enabled: true,
        forceToAxis: true
      },
    }
    return options
  }

  onSlideChange () {
    this.querySelectorAll('.lumin-shoppable-videos-card').forEach(elem => {
      elem.setAttribute('data-is-playing', 'false')
      elem.querySelector('video')?.pause()
    })
  }

  onVideoPlay (video) {
    const card = video.closest('.lumin-shoppable-videos-card')

    this.querySelectorAll('.lumin-shoppable-videos-card').forEach(elem => {
      if (elem.dataset.index !== card.dataset.index) {
        elem.setAttribute('data-is-playing', 'false')
        elem.querySelector('video')?.pause()
      }
    })
    
    if (card.dataset.isPlaying === 'true') {
      card.setAttribute('data-is-playing', 'false')
      video.pause()
    } else {
      card.setAttribute('data-is-playing', 'true')
      video.muted = false
      video.play()
    }
  }
}
customElements.define('lumin-shoppable-videos', KsShoppableVideos)


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wallswipe"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SECTION_SELECTOR = '[data-motw-wall-swipe]';
    const initialized = new WeakSet();

    const parseJson = (root) => {
      const node = root.querySelector('[data-motw-products]');
      if (!node) return [];
      try {
        const value = JSON.parse(node.textContent || '[]');
        return Array.isArray(value) ? value : [];
      } catch (error) {
        console.error('[MoneyOnTheWall] Could not parse product data.', error);
        return [];
      }
    };

    const init = (root) => {
      if (!root || initialized.has(root)) return;
      initialized.add(root);

      let products = parseJson(root);
      const stage = root.querySelector('[data-motw-stage]');
      const stack = root.querySelector('[data-motw-stack]');
      const anchor = root.querySelector('[data-motw-art-anchor]');
      const prev = root.querySelector('[data-motw-prev]');
      const next = root.querySelector('[data-motw-next]');
      const name = root.querySelector('[data-motw-name]');
      const price = root.querySelector('[data-motw-price]');
      const count = root.querySelector('[data-motw-count]');
      const progress = root.querySelector('[data-motw-progress]');
      const live = root.querySelector('[data-motw-live]');
      const save = root.querySelector('[data-motw-save]');
      const saveLabel = root.querySelector('[data-motw-save-label]');
      const heart = root.querySelector('[data-motw-heart]');
      const saveWrap = root.querySelector('[data-motw-save-wrap]');
      const saveToggle = root.querySelector('[data-motw-save-toggle]');
      const savedPanel = root.querySelector('[data-motw-saved-panel]');
      const savedList = root.querySelector('[data-motw-saved-list]');
      const savedCount = root.querySelector('[data-motw-saved-count]');
      const savedEmpty = root.querySelector('[data-motw-saved-empty]');
      const cart = root.querySelector('[data-motw-cart]');
      const cartLabel = root.querySelector('[data-motw-cart-label]');
      const view = root.querySelector('[data-motw-view]');

      if (!products.length || !stage || !stack || !anchor) return;

      const loop = root.dataset.loop === 'true';
      const threshold = Math.max(20, Number(root.dataset.swipeThreshold || 70));
      const duration = Math.max(0, Number(root.dataset.animationDuration || 560));
      const reduced = root.dataset.reducedMotion === 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const actualDuration = reduced ? 0 : duration;
      const removeWhite = root.dataset.removeWhite !== 'false';
      const whiteThreshold = Math.max(155, Math.min(255, Number(root.dataset.whiteThreshold || 250)));
      const frameThreshold = Math.max(60, Math.min(160, Number(root.dataset.frameThreshold || 120)));
      const labels = {
        save: root.dataset.saveLabel || 'Save',
        saved: root.dataset.savedLabel || 'Saved',
        cart: root.dataset.cartLabel || 'Add to cart',
        cartAdded: root.dataset.cartAddedLabel || 'Added',
        counterOf: root.dataset.counterOfLabel || 'of',
        explored: root.dataset.exploredLabel || 'explored',
        statsSeparator: root.dataset.statsSeparator || '·',
        savedCount: root.dataset.savedCountLabel || 'saved',
        soldOut: root.dataset.soldOutLabel || 'Sold out'
      };

      let index = 0;
      let busy = false;
      let pointerId = null;
      let startX = 0;
      let startY = 0;
      let moved = false;
      let saved = new Set();
      let explored = new Set();
      const processed = new Map();
      const MAX_PRODUCTS = Math.min(100, Math.max(1, Number(root.dataset.maxProducts || 100)));
      const EXPLORED_KEY = 'motw_v8_explored';
      const INDEX_KEY = 'motw_v8_index';

      try {
        const stored = JSON.parse(localStorage.getItem('motw_v6_saved') || '[]');
        if (Array.isArray(stored)) saved = new Set(stored.map(String));
      } catch (error) {}

      try {
        const storedExplored = JSON.parse(localStorage.getItem(EXPLORED_KEY) || '[]');
        if (Array.isArray(storedExplored)) explored = new Set(storedExplored.map(String));
      } catch (error) {}

      try {
        const storedIndex = Number(localStorage.getItem(INDEX_KEY));
        if (Number.isFinite(storedIndex) && storedIndex >= 0 && storedIndex < products.length) index = Math.floor(storedIndex);
      } catch (error) {}

      const wrap = (value) => {
        if (loop) return (value + products.length) % products.length;
        return Math.max(0, Math.min(products.length - 1, value));
      };

      const wait = (ms) => new Promise((resolve) => window.setTimeout(resolve, ms));

      const loadImage = (src) => new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.decoding = 'async';
        img.onload = () => resolve(img);
        img.onerror = () => reject(new Error('Artwork image could not be loaded.'));
        img.src = src;
      });

      const isLightNeutral = (data, offset, threshold) => {
        const r = data[offset];
        const g = data[offset + 1];
        const b = data[offset + 2];
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        return r >= threshold && g >= threshold && b >= threshold && max - min <= 24;
      };

      const removeConnectedLight = (ctx, width, height, threshold) => {
        const imageData = ctx.getImageData(0, 0, width, height);
        const data = imageData.data;
        const visited = new Uint8Array(width * height);
        const queue = new Int32Array(width * height);
        let head = 0;
        let tail = 0;

        const pushIfLight = (x, y) => {
          if (x < 0 || y < 0 || x >= width || y >= height) return;
          const idx = y * width + x;
          if (visited[idx]) return;
          const p = idx * 4;
          if (!isLightNeutral(data, p, threshold)) return;
          visited[idx] = 1;
          queue[tail++] = idx;
        };

        for (let x = 0; x < width; x += 1) {
          pushIfLight(x, 0);
          if (height > 1) pushIfLight(x, height - 1);
        }
        for (let y = 1; y < height - 1; y += 1) {
          pushIfLight(0, y);
          if (width > 1) pushIfLight(width - 1, y);
        }

        while (head < tail) {
          const idx = queue[head++];
          const p = idx * 4;
          data[p + 3] = 0;
          const x = idx % width;
          const neighbours = [idx - 1, idx + 1, idx - width, idx + width];
          for (let n = 0; n < neighbours.length; n += 1) {
            const nextIdx = neighbours[n];
            if (nextIdx < 0 || nextIdx >= width * height) continue;
            if ((n === 0 && x === 0) || (n === 1 && x === width - 1)) continue;
            if (visited[nextIdx]) continue;
            const nextP = nextIdx * 4;
            if (!isLightNeutral(data, nextP, threshold)) continue;
            visited[nextIdx] = 1;
            queue[tail++] = nextIdx;
          }
        }

        ctx.putImageData(imageData, 0, 0);
      };

      // The product files are designed with a dark/black physical frame.
      // Instead of trying to guess which white/gray pixels are a Canva shadow,
      // use that frame as the hard boundary: everything outside it is packaging
      // (white background + Canva glow/shadow) and becomes transparent.
      // White pixels INSIDE the frame are never touched.
      const findDarkFrameBounds = (ctx, width, height, threshold) => {
        const imageData = ctx.getImageData(0, 0, width, height);
        const data = imageData.data;
        let minX = width;
        let minY = height;
        let maxX = -1;
        let maxY = -1;
        let darkCount = 0;

        for (let y = 0; y < height; y += 1) {
          for (let x = 0; x < width; x += 1) {
            const p = (y * width + x) * 4;
            const r = data[p];
            const g = data[p + 1];
            const b = data[p + 2];
            if (Math.max(r, g, b) <= threshold) {
              darkCount += 1;
              if (x < minX) minX = x;
              if (y < minY) minY = y;
              if (x > maxX) maxX = x;
              if (y > maxY) maxY = y;
            }
          }
        }

        // Reject implausible detections. The frame should occupy a meaningful
        // central portion of the source, not just a tiny dark logo/detail.
        const frameWidth = maxX - minX + 1;
        const frameHeight = maxY - minY + 1;
        const plausible = maxX >= minX && maxY >= minY &&
          frameWidth >= width * 0.25 && frameHeight >= height * 0.25 &&
          frameWidth <= width * 0.98 && frameHeight <= height * 0.98 &&
          darkCount >= width * height * 0.01;

        return plausible ? { minX, minY, maxX, maxY } : null;
      };

      const removeOutsideFrame = (ctx, width, height, bounds) => {
        if (!bounds) return false;
        const imageData = ctx.getImageData(0, 0, width, height);
        const data = imageData.data;
        for (let y = 0; y < height; y += 1) {
          for (let x = 0; x < width; x += 1) {
            if (x < bounds.minX || x > bounds.maxX || y < bounds.minY || y > bounds.maxY) {
              data[(y * width + x) * 4 + 3] = 0;
            }
          }
        }
        ctx.putImageData(imageData, 0, 0);
        return true;
      };

      const processArtwork = async (product) => {
        if (!product.image) throw new Error('Product has no featured image.');
        const key = `${product.id}|${product.image}|${whiteThreshold}|${frameThreshold}|${removeWhite}`;
        if (processed.has(key)) return processed.get(key);

        const promise = (async () => {
          const source = await loadImage(product.image);
          const originalWidth = source.naturalWidth || source.width;
          const originalHeight = source.naturalHeight || source.height;
          const maxDimension = 1600;
          const scale = Math.min(1, maxDimension / Math.max(originalWidth, originalHeight));
          const width = Math.max(1, Math.round(originalWidth * scale));
          const height = Math.max(1, Math.round(originalHeight * scale));

          const canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d', { willReadFrequently: true });
          if (!ctx) throw new Error('Canvas is unavailable.');
          ctx.drawImage(source, 0, 0, width, height);

          if (removeWhite) {
            // Primary method: trust the physical black frame as the artwork boundary.
            // This removes the entire Canva white/gray halo in one deterministic step.
            const frameBounds = findDarkFrameBounds(ctx, width, height, frameThreshold);
            const frameDetected = removeOutsideFrame(ctx, width, height, frameBounds);

            // Fallback for products without a dark frame.
            if (!frameDetected) {
              removeConnectedLight(ctx, width, height, whiteThreshold);
              removeConnectedLight(ctx, width, height, Math.max(155, Math.min(255, whiteThreshold - 8))); 
            }
          }

          const pixels = ctx.getImageData(0, 0, width, height).data;
          let minX = width, minY = height, maxX = -1, maxY = -1;
          const alphaThreshold = 8;
          for (let y = 0; y < height; y += 1) {
            for (let x = 0; x < width; x += 1) {
              const a = pixels[(y * width + x) * 4 + 3];
              if (a > alphaThreshold) {
                if (x < minX) minX = x;
                if (y < minY) minY = y;
                if (x > maxX) maxX = x;
                if (y > maxY) maxY = y;
              }
            }
          }

          if (maxX < minX || maxY < minY) throw new Error('The artwork became empty after processing.');

          const padding = Math.max(2, Math.round(Math.max(width, height) * 0.006));
          minX = Math.max(0, minX - padding);
          minY = Math.max(0, minY - padding);
          maxX = Math.min(width - 1, maxX + padding);
          maxY = Math.min(height - 1, maxY + padding);

          const cropWidth = maxX - minX + 1;
          const cropHeight = maxY - minY + 1;
          const cropped = document.createElement('canvas');
          cropped.width = cropWidth;
          cropped.height = cropHeight;
          const croppedCtx = cropped.getContext('2d');
          if (!croppedCtx) throw new Error('Crop canvas is unavailable.');
          croppedCtx.drawImage(canvas, minX, minY, cropWidth, cropHeight, 0, 0, cropWidth, cropHeight);

          const blob = await new Promise((resolve, reject) => {
            cropped.toBlob((value) => value ? resolve(value) : reject(new Error('Could not create transparent artwork.')), 'image/png');
          });
          const url = URL.createObjectURL(blob);
          return { url, width: cropWidth, height: cropHeight, ratio: cropWidth / cropHeight };
        })();

        processed.set(key, promise);
        return promise;
      };

      const getExploredCount = () => products.reduce((total, product) => total + (explored.has(String(product.id)) ? 1 : 0), 0);

      const persistExplored = () => {
        try {
          localStorage.setItem(EXPLORED_KEY, JSON.stringify([...explored]));
        } catch (error) {}
      };

      const markExplored = (product) => {
        if (!product) return;
        const key = String(product.id);
        if (explored.has(key)) return;
        explored.add(key);
        persistExplored();
      };

      const updateInfo = () => {
        const product = products[index];
        if (!product) return;
        markExplored(product);
        const exploredCount = getExploredCount();
        if (name) name.textContent = product.title || '';
        if (price) price.textContent = product.price || '';
        if (count) {
          const separator = labels.statsSeparator ? ` ${labels.statsSeparator} ` : ' ';
          count.textContent = `${index + 1} ${labels.counterOf} ${products.length} ${labels.explored}${separator}${saved.size} ${labels.savedCount}`.trim();
        }
        if (progress) progress.style.width = `${Math.max(0, Math.min(100, ((index + 1) / Math.max(1, products.length)) * 100))}%`;
        if (view) view.href = product.url || '#';
        if (cart) {
          cart.disabled = !product.available || !product.variant_id;
          if (cartLabel) cartLabel.textContent = product.available ? labels.cart : labels.soldOut;
        }
        if (save) {
          const isSaved = saved.has(String(product.id));
          save.setAttribute('aria-pressed', String(isSaved));
          save.classList.toggle('is-saved', isSaved);
          if (heart) heart.setAttribute('data-saved', String(isSaved));
          if (saveLabel) saveLabel.textContent = isSaved ? labels.saved : labels.save;
        }
        if (live) live.textContent = product.title || '';
      };

      const makeCard = async (product, direction) => {
        const processedArtwork = await processArtwork(product);
        const card = document.createElement('div');
        const img = document.createElement('img');
        card.className = 'motw-v6-card';
        card.dataset.ratio = String(processedArtwork.ratio);
        img.src = processedArtwork.url;
        img.alt = product.alt || product.title || '';
        img.draggable = false;
        card.appendChild(img);

        const anchorRect = anchor.getBoundingClientRect();
        const ratio = Math.max(.2, Math.min(5, processedArtwork.ratio || 1));
        const areaFactor = .56;
        const scale = Number(root.style.getPropertyValue('--motw-art-scale')) || 1;
        const maxWidth = anchorRect.width;
        const maxHeight = anchorRect.height;
        const targetArea = maxWidth * maxHeight * areaFactor * scale * scale;
        let cardWidth = Math.sqrt(targetArea * ratio);
        let cardHeight = cardWidth / ratio;
        if (cardWidth > maxWidth) {
          cardWidth = maxWidth;
          cardHeight = cardWidth / ratio;
        }
        if (cardHeight > maxHeight) {
          cardHeight = maxHeight;
          cardWidth = cardHeight * ratio;
        }
        card.style.width = `${Math.max(40, Math.round(cardWidth))}px`;
        card.style.height = `${Math.max(40, Math.round(cardHeight))}px`;
        card.style.setProperty('--motw-scale', '1');
        stack.appendChild(card);
        if (direction !== 0) {
          const start = direction > 0 ? 1 : -1;
          card.style.transform = `translate3d(calc(-50% + ${start * 110}vw), -50%, 0)`;
          card.style.opacity = '0';
          card.getBoundingClientRect();
          card.style.transition = `transform ${actualDuration}ms ${getComputedStyle(root).getPropertyValue('--motw-animation-ease') || 'cubic-bezier(.22,.61,.36,1)'}, opacity ${Math.max(120, actualDuration * .65)}ms ease`;
          card.style.transform = 'translate3d(-50%, -50%, 0)';
          card.style.opacity = '1';
        }
        return card;
      };

      const loadAdditionalProducts = async () => {
        if (products.length >= MAX_PRODUCTS) return;
        const sectionId = root.dataset.sectionId;
        if (!sectionId) return;
        const url = new URL(window.location.href);
        url.searchParams.set('section_id', sectionId);
        url.searchParams.set('page', '2');
        try {
          const response = await fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
          if (!response.ok) throw new Error(`Section request failed: ${response.status}`);
          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const node = doc.querySelector('[data-motw-products]');
          if (!node) return;
          const additional = JSON.parse(node.textContent || '[]');
          if (!Array.isArray(additional) || !additional.length) return;
          const existing = new Set(products.map((product) => String(product.id)));
          additional.forEach((product) => {
            if (products.length >= MAX_PRODUCTS) return;
            if (!existing.has(String(product.id))) {
              products.push(product);
              existing.add(String(product.id));
            }
          });
          updateInfo();
          renderSavedPanel();
          preload(index + 1);
        } catch (error) {
          console.warn('[MoneyOnTheWall] Could not load the second artwork page.', error);
        }
      };

      const ensureCurrent = async () => {
        stack.innerHTML = '';
        const card = await makeCard(products[index], 0);
        card.dataset.current = 'true';
        updateInfo();
      };

      const preload = (targetIndex) => {
        const product = products[wrap(targetIndex)];
        if (!product) return;
        processArtwork(product).catch(() => {});
      };

      const go = async (direction) => {
        if (busy || products.length < 2) return;
        const rawTarget = index + direction;
        if (!loop && (rawTarget < 0 || rawTarget >= products.length)) return;
        const target = wrap(rawTarget);
        if (target === index) return;
        busy = true;

        const current = stack.querySelector('[data-current="true"]');
        let incoming;
        try {
          incoming = await makeCard(products[target], direction);
        } catch (error) {
          console.error('[MoneyOnTheWall] Artwork processing failed.', error);
          busy = false;
          return;
        }

        incoming.dataset.current = 'false';
        if (current) {
          current.style.transition = `transform ${actualDuration}ms ${getComputedStyle(root).getPropertyValue('--motw-animation-ease') || 'cubic-bezier(.22,.61,.36,1)'}, opacity ${Math.max(120, actualDuration * .65)}ms ease`;
          current.style.transform = `translate3d(${direction > 0 ? '-110vw' : '110vw'}, -50%, 0) scale(${root.style.getPropertyValue('--motw-art-scale') || 1})`;
          current.style.opacity = '0';
        }

        await wait(actualDuration + 20);
        if (current && current.parentNode === stack) current.remove();
        incoming.dataset.current = 'true';
        index = target;
        try { localStorage.setItem(INDEX_KEY, String(index)); } catch (error) {}
        updateInfo();
        preload(index + 1);
        preload(index - 1);
        busy = false;
      };

      const onPrev = (event) => { event.stopPropagation(); go(-1); };
      const onNext = (event) => { event.stopPropagation(); go(1); };

      prev && prev.addEventListener('click', onPrev);
      next && next.addEventListener('click', onNext);

      const onPointerDown = (event) => {
        if (busy || event.target.closest('[data-motw-prev],[data-motw-next]')) return;
        pointerId = event.pointerId;
        startX = event.clientX;
        startY = event.clientY;
        moved = false;
        try { stage.setPointerCapture(pointerId); } catch (error) {}
      };

      const onPointerMove = (event) => {
        if (pointerId !== event.pointerId || busy) return;
        const dx = event.clientX - startX;
        const dy = event.clientY - startY;
        if (Math.abs(dx) > 8 || Math.abs(dy) > 8) moved = true;
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 10) event.preventDefault();
      };

      const onPointerUp = (event) => {
        if (pointerId !== event.pointerId) return;
        const dx = event.clientX - startX;
        const dy = event.clientY - startY;
        pointerId = null;
        if (!moved || Math.abs(dx) < threshold || Math.abs(dx) <= Math.abs(dy)) return;
        go(dx < 0 ? 1 : -1);
      };

      stage.addEventListener('pointerdown', onPointerDown);
      stage.addEventListener('pointermove', onPointerMove, { passive: false });
      stage.addEventListener('pointerup', onPointerUp);
      stage.addEventListener('pointercancel', onPointerUp);

      const onKeyDown = (event) => {
        if (event.key === 'ArrowLeft') { event.preventDefault(); go(-1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); go(1); }
      };
      root.addEventListener('keydown', onKeyDown);

      const persistSaved = () => {
        try {
          localStorage.setItem('motw_v6_saved', JSON.stringify([...saved]));
        } catch (error) {}
      };

      const renderSavedPanel = () => {
        if (!savedList || !savedCount || !savedEmpty) return;
        const savedProducts = products.filter((product) => saved.has(String(product.id)));
        savedCount.textContent = String(savedProducts.length);
        savedList.innerHTML = '';

        savedProducts.forEach((product) => {
          const item = document.createElement('button');
          item.type = 'button';
          item.className = 'motw-v6-saved-item';
          item.dataset.savedProductId = String(product.id);

          const thumb = document.createElement('img');
          thumb.className = 'motw-v6-saved-thumb';
          thumb.src = product.image || '';
          thumb.alt = product.alt || product.title || '';
          thumb.loading = 'lazy';
          thumb.draggable = false;

          const copy = document.createElement('span');
          copy.style.minWidth = '0';

          const title = document.createElement('span');
          title.className = 'motw-v6-saved-name';
          title.textContent = product.title || '';

          copy.appendChild(title);

          const arrow = document.createElement('span');
          arrow.className = 'motw-v6-saved-open';
          arrow.setAttribute('aria-hidden', 'true');
          arrow.textContent = '›';

          item.appendChild(thumb);
          item.appendChild(copy);
          item.appendChild(arrow);
          savedList.appendChild(item);
        });

        savedEmpty.hidden = savedProducts.length > 0;
      };

      const setSavedPanelOpen = (open) => {
        if (!savedPanel || !saveWrap || !saveToggle) return;
        savedPanel.hidden = !open;
        saveWrap.classList.toggle('is-open', open);
        saveToggle.setAttribute('aria-expanded', String(open));
        renderSavedPanel();
      };

      const onSave = () => {
        const product = products[index];
        if (!product || !save) return;
        const key = String(product.id);
        if (saved.has(key)) saved.delete(key); else saved.add(key);
        persistSaved();
        updateInfo();
        renderSavedPanel();
      };

      const onSaveToggle = (event) => {
        event.stopPropagation();
        const open = saveToggle.getAttribute('aria-expanded') !== 'true';
        setSavedPanelOpen(open);
      };

      const onSavedItemClick = async (event) => {
        const item = event.target.closest('[data-saved-product-id]');
        if (!item) return;
        const targetId = String(item.dataset.savedProductId);
        const targetIndex = products.findIndex((product) => String(product.id) === targetId);
        if (targetIndex < 0) return;
        setSavedPanelOpen(false);
        index = targetIndex;
        try { localStorage.setItem(INDEX_KEY, String(index)); } catch (error) {}
        busy = true;
        try {
          await ensureCurrent();
          preload(index + 1);
          preload(index - 1);
        } finally {
          busy = false;
        }
      };

      save && save.addEventListener('click', onSave);
      saveToggle && saveToggle.addEventListener('click', onSaveToggle);
      savedList && savedList.addEventListener('click', onSavedItemClick);
      renderSavedPanel();

      const onCart = async () => {
        const product = products[index];
        if (!product || !product.variant_id || !product.available || !cart) return;
        cart.disabled = true;
        try {
          const rootUrl = root.dataset.localeRoot || '/';
          const response = await fetch(`${rootUrl}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(product.variant_id), quantity: 1 }] })
          });
          if (!response.ok) throw new Error('Cart request failed.');
          await response.json();
          if (cartLabel) cartLabel.textContent = labels.cartAdded;
          try {
            const cartState = await fetch(`${rootUrl}cart.js`, { headers: { 'Accept': 'application/json' } }).then((r) => r.json());
            document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { detail: cartState }));
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: cartState }));
          } catch (error) {}
          window.setTimeout(() => {
            if (cartLabel) cartLabel.textContent = labels.cart;
            cart.disabled = false;
          }, 1600);
        } catch (error) {
          console.error('[MoneyOnTheWall] Could not add product to cart.', error);
          cart.disabled = false;
        }
      };
      cart && cart.addEventListener('click', onCart);

      ensureCurrent().then(() => {
        preload(index + 1);
        preload(index - 1);
        loadAdditionalProducts();
      });
    };

    const scan = (scope) => {
      const roots = scope && scope.matches && scope.matches(SECTION_SELECTOR)
        ? [scope]
        : Array.from((scope || document).querySelectorAll(SECTION_SELECTOR));
      roots.forEach(init);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
    } else {
      scan(document);
    }

    document.addEventListener('shopify:section:load', (event) => scan(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
